'use client';
import styled from 'styled-components';

export const PastSearchesTitle = styled.div`
  color: ${({ theme }) => theme.palette.grey800};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  flex: 1;
`;

export const IconButton = styled.button`
  all: unset;
  cursor: pointer;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  min-width: 0;
`;

export const ItelLabel = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  flex: 1;
  margin-left: 12px;
  min-width: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  b {
    font-weight: 600;
  }
`;
export const SubLabel = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 12px;
  line-height: 16px;
  flex: 1;
  margin-left: 12px;
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 0;
`;
